var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ueqCkmp",attrs:{"id":"defaultId1","name":"header"}},[_c('div',{staticClass:"u687b7",attrs:{"id":"gf9e12"}},[_vm._t("default",null,{"id":"c605d2"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }